/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { axiosProtectedApi, axiosWebservice } from './setup';
import qs from 'qs';

export async function addToMyContacts (contact, isFav) {
  let url = null;
  let data = null;
  if (contact && contact.userhash) {
    url = 'user/contact/add';
    data = {
      userhashs: [contact.userhash],
      isfav: !!isFav
    };
  } else if (contact && contact.number_short) {
    url = 'user/contact/createnew';
    data = {
      name: contact.customer,
      devices: [
        {
          number: contact.number_short,
          type: 'H323',
          typename: 'H323 Id',
          isdefault: true
        }
      ],
      pic: contact.haspic ? contact.profilepic : '',
      isfav: !!isFav
    };
  }
  if (url && data) {
    const api = axiosProtectedApi();
    const response = await api.post(url, qs.stringify(data));
    return response && response.data && response.data.status
      ? response.data
      : null;
  } else {
    return false;
  }
}

export async function removeContacts (contact) {
  const api = axiosProtectedApi();
  const response = await api.post(
    '/user/contact/remove',
    qs.stringify({
      ids: [contact.id]
    })
  );
  return response && response.data && response.data.status;
}

export async function toggleFavorite ({ isfav, id }) {
  const api = axiosProtectedApi();
  const response = await api.post(
    isfav ? 'user/contact/rmfavorites' : 'user/contact/favorites',
    qs.stringify({
      ids: [id]
    })
  );

  return response && response.data && response.data.status;
}

let CancelTokenSourceSearchContacts = null;
export async function searchContacts (term, isLoggedIn, isLocal) {
  const api = axiosWebservice();
  if (CancelTokenSourceSearchContacts) {
    CancelTokenSourceSearchContacts.cancel('New Request Started.');
  }
  CancelTokenSourceSearchContacts = api.CancelTokenSource;
  const data = {
    contact: term,
    limit: 10,
    start: 0,
    authorized: isLoggedIn
  };
  if (isLocal) {
    data.local = isLocal;
  }
  const response = await api.post(
    'search',
    qs.stringify(data)
  );
  CancelTokenSourceSearchContacts = null;

  return response && response.data ? response.data : [];
}
